// import { fastRaf, throttleWith } from '../../util/schedulers'
import { addEffect, addLayoutEffect } from '../teact/teact'
// import safeExec from '../../util/safeExec'

// import { setPhase } from './stricterdom'

// let pendingMeasureTasks: NoneToVoidFunction[] = []
// let pendingMutationTasks: NoneToVoidFunction[] = []
// let pendingForceReflowTasks: (() => NoneToVoidFunction | void)[] = []

// const runUpdatePassOnRaf = throttleWithRafFallback(() => {
//   const currentMeasureTasks = pendingMeasureTasks
//   pendingMeasureTasks = []
//   currentMeasureTasks.forEach((task) => {
//     safeExec(task)
//   })

//   // We use promises to provide correct order for Mutation Observer callback microtasks
//   Promise.resolve()
//     .then(() => {
//       setPhase('mutate')

//       const currentMutationTasks = pendingMutationTasks
//       pendingMutationTasks = []

//       currentMutationTasks.forEach((task) => {
//         safeExec(task)
//       })
//     })
//     .then(() => {
//       setPhase('measure')

//       const pendingForceReflowMutationTasks: NoneToVoidFunction[] = []
//       // Will include tasks created during the loop
//       for (const task of pendingForceReflowTasks) {
//         safeExec(() => {
//           const mutationTask = task()
//           if (mutationTask) {
//             pendingForceReflowMutationTasks.push(mutationTask)
//           }
//         })
//       }
//       pendingForceReflowTasks = []

//       return pendingForceReflowMutationTasks
//     })
//     .then((pendingForceReflowMutationTasks) => {
//       setPhase('mutate')

//       // Will include tasks created during the loop
//       for (const task of pendingForceReflowMutationTasks) {
//         safeExec(task)
//       }
//     })
//     .then(() => {
//       setPhase('measure')
//     })
// })

export function requestMeasure(cb: NoneToVoidFunction) {
  // pendingMeasureTasks.push(cb)
  // runUpdatePassOnRaf()
  addLayoutEffect(cb)
}

export function requestMutation(cb: NoneToVoidFunction) {
  // pendingMutationTasks.push(cb)
  // runUpdatePassOnRaf()
  addEffect(cb)
}

export function requestNextMutation(cb: () => NoneToVoidFunction | void) {
  requestMeasure(() => {
    requestMutation(cb)
  })
}

export function requestForcedReflow(cb: () => NoneToVoidFunction | void) {
  // pendingForceReflowTasks.push(cb)
  // runUpdatePassOnRaf()
  addLayoutEffect(() => {
    const mutationTask = cb()
    if (mutationTask) {
      addEffect(mutationTask, true)
    }
  })
}

// function throttleWithRafFallback<F extends AnyToVoidFunction>(fn: F) {
//   return throttleWith((throttledFn: NoneToVoidFunction) => {
//     fastRaf(throttledFn, true)
//   }, fn)
// }

export * from './stricterdom'
